/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, type ReactNode } from "react";
import type { Category, Product, SiteSettings } from "../types/catalog";

export type PublicCatalog = {
  categories: Category[];
  products: Product[];
  settings: SiteSettings;
};

export type PageSnapshot = PublicCatalog & { path: string };

const PublicCatalogContext = createContext<PublicCatalog | undefined>(undefined);

export function PublicCatalogProvider({ catalog, children }: { catalog?: PublicCatalog; children: ReactNode }) {
  return <PublicCatalogContext.Provider value={catalog}>{children}</PublicCatalogContext.Provider>;
}

export function useInitialCatalog() {
  return useContext(PublicCatalogContext);
}

export function readPageSnapshot(): PageSnapshot | undefined {
  const element = document.getElementById("catalog-snapshot");
  if (!element?.textContent) return undefined;

  try {
    return JSON.parse(element.textContent) as PageSnapshot;
  } catch {
    return undefined;
  }
}
